export enum GlobalActions {
  FetchCountries = "fetchCountries",
}
